import { simpleSet } from '@r/reducers/utils';

const setCalculationModeMainModalTab = simpleSet as
  redux.reducers.calculationMode.tabs.mainModal;

export const mainModal = setCalculationModeMainModalTab(
  'SET_CALCULATION_MODE_MAIN_MODAL_TAB',
  'createNewProject'
);
